// Shared formatting for the preliminary estimate so the desktop panel, the
// mobile drawer, and the send-inquiry modal stay consistent — including the
// "custom quote" cases the pricing engine returns. A custom quote can be driven
// by either an area below the threshold (reason 'area') or by products that are
// always priced manually (reason 'products'). A partial custom quote pairs a
// real range with a note that some selected products are quoted individually.

export const CUSTOM_QUOTE_LABEL = 'Custom quote';

// Reason-specific subtext under the "Custom quote" heading.
export const CUSTOM_QUOTE_DETAIL_AREA = 'Your area is below our standard threshold — '
  + "we'll prepare a custom quote after you send your inquiry.";

export const CUSTOM_QUOTE_DETAIL_PRODUCTS = 'The products you selected are priced '
  + "individually — we'll prepare a custom quote after you send your inquiry.";

// Backwards-compatible default (the original area-driven message).
export const CUSTOM_QUOTE_DETAIL = CUSTOM_QUOTE_DETAIL_AREA;

// Note shown beneath a real range when some (but not all) selected products are
// quoted individually.
export const PARTIAL_CUSTOM_QUOTE_NOTE = 'Some selected products are quoted '
  + "individually and aren't included in this range.";

const formatDollar = (n) => (n == null ? '—' : `$${Number(n).toLocaleString()}`);

export const isCustomQuote = (data) => Boolean(data?.customQuote);

// True when a real range is shown but some products still need a manual quote.
export const isPartialCustomQuote = (data) => Boolean(data?.partialCustomQuote);

// The subtext for a full custom quote, chosen by the engine's reason.
export const customQuoteDetail = (data) => (
  data?.customQuoteReason === 'products'
    ? CUSTOM_QUOTE_DETAIL_PRODUCTS
    : CUSTOM_QUOTE_DETAIL_AREA
);

// Short one-line representation of the estimate (range or custom-quote label).
export const estimateRangeText = (data) => {
  if (!data) return null;
  if (data.customQuote) return CUSTOM_QUOTE_LABEL;
  return `${formatDollar(data.low)} – ${formatDollar(data.high)}`;
};
